const getCookie = function (name) {
  var strcookie = document.cookie; //获取cookie字符串
  var arrcookie = strcookie.split("; "); //分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] === name) {
      return arr[1];
    }
  }
  return "";
};
const setCookie = function (key, value) {
  document.cookie = `${key}=${value}`;
};
const cloneObj = function (obj) {
  var newObj = {};
  if (obj instanceof Array) {
    newObj = [];
  }
  for (var key in obj) {
    var val = obj[key];
    newObj[key] = typeof val === "object" ? cloneObj(val) : val;
  }
  return newObj;
};
const formatNumber = function (num) {
  var decimalPart = "";
  num = num.toString();
  if (num.indexOf(".") !== -1) {
    decimalPart = "." + num.split(".")[1];
    num = parseInt(num.split(".")[0], 10);
  }
  var array = num.toString().split("");
  var index = -3;
  while (array.length + index > 0) {
    array.splice(index, 0, ",");
    index -= 4;
  }
  return array.join("") + decimalPart;
};
const formatDate = function (fmt, date) {
  let dates = new Date(date);
  if (JSON.stringify(dates) === "null") {
    return "";
  }
  var o = {
    "M+": dates.getMonth() + 1, //月份
    "d+": dates.getDate(), //日
    "h+": dates.getHours(), //小时
    "m+": dates.getMinutes(), //分
    "s+": dates.getSeconds(), //秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (dates.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

//转换日期和时间
const formatTime = function (time, format) {
  var t = new Date(time);
  var tf = function (i) {
    return (i < 10 ? "0" : "") + i;
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (str) {
    switch (str) {
      case "yyyy":
        return tf(t.getFullYear());
      case "MM":
        return tf(t.getMonth() + 1);
      case "mm":
        return tf(t.getMinutes());
      case "dd":
        return tf(t.getDate());
      case "HH":
        return tf(t.getHours());
      case "ss":
        return tf(t.getSeconds());
      default:
      // do nothing
    }
  });
};

// 字符串反转义
const deXMLFilter = (text) => {
  try {
    if(!text) return
    const matchList = {
      "&lt;": "<",
      "&gt;": ">",
      "&amp;": "&",
      "&#34;": '"',
      "&quot;": '"',
      "&#39;": "'",
      "&lsquo;": "‘",
      "&rsquo;": "’",
      "&ldquo;": "“",
      "&rdquo;": "”",
      "&times;": "×",
      "&divide;": "÷",
      "&ndash;":"–",
      "&mdash;":"—",
      "&yen;":"¥",
      "&bull;":'•',
      "&middot;":'·',
      "&hellip;":"…",
      "&laquo;":"«",
      "&raquo;":"»"
    };
    let regStr = "(" + Object.keys(matchList).toString() + ")";
    // ↑ ------------【*提取匹配列表key值*】.【组数转字符串】
    regStr = regStr.replace(/,/g, ")|(");
    // ↑ 通过匹配将其更新为正则的字符串类型
    const regExp = new RegExp(regStr, "g");
    // ↑ ------- 字符串 转 正则 方法
    let re = text.replace(regExp, (match) => matchList[match])
    // 如果还存在转以后的编码，递归调用反转义方法
    if(re.search(regExp, (match) => matchList[match]) > 0) {
      // 每次调用必须返回该函数, 每次return都是把最新的函数调用返回给外层的函数调用
      // 否则得到的值是undefined
      return deXMLFilter(re)
    } else {
      return uncodeUtf16(re)
    }
  } catch(e) {
    console.error(e,'-------字符串反转义错误-------')
    return text
  }
}


/**
 * 对emoji表情转反义
 * @method utf16toEntities
 * @param {*} strs
 * @returns
 */
 const uncodeUtf16 = (strs) => {
  let str = strs;
  if (!str) {
    str = '';
  }
  try {
    str = str.toString();
  } catch (err) {
    return str;
  }
  // eslint-disable-next-line no-useless-escape
  const reg = /\&#.*?;/g;
  const result = str.replace(reg, (char) => {
    let H;
    let L;
    let code;
    if (char.length === 9) {
      // eslint-disable-next-line radix
      code = parseInt(char.match(/[0-9]+/g));
      H = Math.floor((code - 0x10000) / 0x400) + 0xd800;
      L = ((code - 0x10000) % 0x400) + 0xdc00;
      return unescape(`%u${H.toString(16)}%u${L.toString(16)}`);
    }
    return char;
  });
  return result;
};

export { getCookie, cloneObj, formatNumber, formatDate, setCookie, formatTime, deXMLFilter };
